import { RouterModule, Routes } from '@angular/router';
import {ParametersComponent} from './parameters/parameters.component';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
// Page Layouts
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';
import {SearchComponent} from './search/search.component';


const AppRoutes: Routes = [
    { path: '', redirectTo: '/app/documents', pathMatch: 'full'},   
    // { path: '', redirectTo: '/extra/login', pathMatch: 'full' },   
    { path: 'app', component: LayoutComponent, canActivate: [OktaAuthGuard] },
    { path: 'login/callback', component: OktaCallbackComponent },
    {
        path: 'extra', 
        loadChildren: () => import('./extra-pages/extra-pages.module').then(m => m.ExtraPagesModule)
      },
          { path: 'fullscreen', component: PageLayoutFullscreenComponent },
    { path: '**', redirectTo: '/app/documents', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});
